// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type InventoryPaths = paths;
export const INVENTORY_SERVICE = "inventory" as const;

/** Typed openapi-fetch client for the inventory service (schema `inventory`). */
export function createInventoryClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("inventory", options);
}

export type InventoryClient = ReturnType<typeof createInventoryClient>;
